import { Divider, Flex, Stack, useColorModeValue, Link } from '@chakra-ui/react';
import * as React from 'react';
import { FiHelpCircle, FiHome, FiSettings, FiLogOut } from 'react-icons/fi';
import { Logo } from './chakraUIPro/Logo';
import { NavButton } from './dashboard/NavButton';

export const Sidebar = ({ organisation }) => (
  <Flex as='section' minH='100vh' bg='bg-canvas'>
    <Flex
      flex='1'
      bg='bg-surface'
      overflowY='auto'
      boxShadow={useColorModeValue('sm', 'sm-dark')}
      maxW={{ base: 'full', sm: 'xs' }}
      py={{ base: '6', sm: '8' }}
      px={{ base: '4', sm: '6' }}
    >
      <Stack justify='space-between' spacing='1'>
        <Stack spacing={{ base: '3', sm: '5' }} shouldWrapChildren>
          <Flex>
            <Logo />
            {/* <Text fontWeight='bold' fontSize='2xl' color={useColorModeValue('black', 'white')}>
              eezi
            </Text> */}
          </Flex>
          {/* <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon as={FiSearch} color="muted" boxSize="5" />
            </InputLeftElement>
            <Input placeholder="Search" />
          </InputGroup> */}
          <Stack spacing='1'>
            <Link href={`/dashboard/${organisation?.id || ''}`}>
              <NavButton label='Dashboard' icon={FiHome} aria-current='page' />
            </Link>
            <Link href={`/users/${organisation?.id || ''}`}>
              <NavButton label='Users' icon={FiHelpCircle} />
            </Link>
          </Stack>
        </Stack>
        <Stack spacing={{ base: '5', sm: '6' }}>
          <Stack spacing='1'>
            <NavButton label='Settings' icon={FiSettings} />
            <Link href='/sign-out/'>
              <NavButton label='Sign out' icon={FiLogOut} />
            </Link>
          </Stack>
          <Divider />
          {/* TODO: add profile image on mobile navbar */}
          {/* <UserProfile name='Christoph Winston' image='https://tinyurl.com/yhkm2ek8' email='chris@chakra-ui.com' /> */}
        </Stack>
      </Stack>
    </Flex>
  </Flex>
);
